import styled from 'styled-components';

export const InfoFlex = styled.div`
  display: flex;
  gap: 1.5rem;

  > p {
    &:nth-child(2) {
      font-weight: 900;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;

export const GaugeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: .75rem;
  gap: 1rem;
`;

export const Title = styled.p`
  font-size: 1.5rem;
`;